import './Footer.scss';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Logo from '../../assets/NewLogo.svg';
import LogoText from '../../assets/Pioneers.svg';

const Footer = ({ onFormClick }) => {
  const navigate = useNavigate();

  const handleCookieClick = () => {
    window.displayPreferenceModal();
  };

  return (
    <div className='footer'>
      <div className='footerContent'>
        <div className='contentBlock'>
          <div className='headerLogo'>
            <img src={Logo} alt='Logo' />
            <img src={LogoText} alt='Logo' />
          </div>
          <span className='footerText'>AI-powered staffing and acquisitions platform. Shaping the future of recruitment.</span>
        </div>
        <div className='contentBlockLinks'>
          <div className='contentBlock'>
            <span className='footerLinksTitle'>Company</span>
            <div className='footerLinks'>
              <span className='footerLink' onClick={() => navigate('/about')}>
                About us
              </span>
              <span className='footerLink' onClick={() => navigate('/platform')}>
                Platform
              </span>
              <span className='footerLink' onClick={() => onFormClick('Looking to hire talent')}>
                Contact
              </span>
            </div>
          </div>

          <div className='contentBlock'>
            <span className='footerLinksTitle'>Services</span>
            <div className='footerLinks'>
              <span className='footerLink' onClick={() => navigate('/solutions')}>
                Staffing Solutions
              </span>
              <span className='footerLink' onClick={() => navigate('/acquisitions')}>
                Acquisitions
              </span>
            </div>
          </div>
        </div>
        <div className='contentBlock policyBlock'>
          <div className='footerLinks'>
            <span
              className='footerLink'
              onClick={() =>
                window.open(
                  'https://app.termly.io/policy-viewer/policy.html?policyUUID=299f2ef4-42a3-40b7-afb0-9bbe23c90094',
                  '_blank',
                )
              }
            >
              Privacy Policy
            </span>
            <span
              className='footerLink'
              onClick={() =>
                window.open(
                  'https://app.termly.io/policy-viewer/policy.html?policyUUID=9b6204f8-18a5-4cf3-a92a-bbcee6fe25b9',
                  '_blank',
                )
              }
            >
              Terms and Conditions
            </span>
            <span class='footerLink' onClick={handleCookieClick}>
              Consent Preferences
            </span>
          </div>
          <span className='footerText'>© {format(new Date(), 'yyyy')} Pioneers. All rights reserved.</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
